import { type ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { Alert, AlertDescription } from "@/components/ui/alert";
import { useMe } from "@/queries/auth";

interface AdminGuardProps {
  children: ReactNode;
}

export function AdminGuard({ children }: AdminGuardProps) {
  const { t } = useTranslation("admin-users");
  const { data: me } = useMe();

  if (!me) return null;
  if (me.role !== "admin") {
    return (
      <div className="mx-auto max-w-xl p-6">
        <Alert variant="destructive">
          <AlertDescription>{t("guards.notAdmin")}</AlertDescription>
        </Alert>
      </div>
    );
  }
  return <>{children}</>;
}
